module.exports = __webpack_public_path__ + "static/media/hand-up-hover.71196171.png";